import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

import { verifyPasswordResetCode } from 'store/actions/resetPassword';
import { fetchReset } from 'store/actions/entities';
import Stage2 from 'components/ResetPasswordStages/Stage2/index';

export default withTranslation()(
  connect(null, { verifyPasswordResetCode, fetchReset })(Stage2),
);
